'use strict';

/** @type {import('./abs')} */
module.exports = Math.abs;



//////////////////
// WEBPACK FOOTER
// ./~/_math-intrinsics@1.1.0@math-intrinsics/abs.js
// module id = 1597
// module chunks = 0